<template>
  <div>
    <the-header />
    <SitesOffline
      title="Coronavirus (COVID-19) Update"
      description="Please be aware that sales are currently suspended for the site-specific digital pass at this location due to impacts from the coronavirus (COVID-19).  We will provide updates as the situation evolves. We appreciate your patience and understanding."
      v-if="siteOffline"
    />
    <SitesOffline
      title="Maintenance"
      description="Passes for the selected park are not available due to system maintenance.  Sorry for the inconvenience."
      v-if="siteOfflineMaintenance"
    />
    <section id="page-content" v-else>
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <header class="header-page">
              <h1 id="parkName">{{ siteInfo.name }}</h1>
              <div class="step-progress-bar">
                <div class="step-progress" style="width: 25%"></div>
              </div>
            </header>
            <div v-if="this.$route.query.additional" class="alert alert-info">
              Add additional {{ siteInfo.name }} pass.
            </div>
            <!-- <div class="row">
              <div class="col-sm-6 col-xs-12">
                <h2>Pass Data - {{siteId}}</h2>
                <pre>{{pass}}</pre>
                <pre>{{errors}}</pre>
              </div>  
            </div>-->
            <span v-if="!passMetadata.rows">
              <font-awesome-icon
                icon="spinner"
                class="fa fa-fw fa-pulse fa-2x"
              />One moment...
              <br />
              <br />
            </span>
            <fee-display
              v-if="passDefinition.pass_types"
              :passtypes="passDefinition.pass_types"
              :pricingDescriptions="pricingDescriptions"
            />
            <pass-input-fields
              category="passinfo"
              title="Pass Info"
              :pass="pass"
              @passUpdated="passUpdated"
              :siteId="siteId"
              :errors="errors"
              :passMetadata="passMetadata"
            />
            <div
              v-if="
                this.passTypeDefinition &&
                this.passTypeDefinition.duration === 'segment'
              "
            >
              <day-night
                :startDate="pass['start-date'] | formatDate"
                :endDate="pass.enddate | formatDate"
                :errors="errors"
                @passUpdated="passUpdated"
              />
            </div>
            <pass-input-fields
              category="visitorinfo"
              title="Visitor Info"
              :pass="pass"
              :siteId="siteId"
              @passUpdated="passUpdated"
              :errors="errors"
              :passMetadata="passMetadata"
            />
            <discount
              v-if="passMetadata.showDiscount"
              :error="errors['discountPassNumber']"
              @change="passUpdated"
              :discountPassNumber="pass.discountPassNumber"
            />
            <br />
            <div class="row">
              <div class="col-md-8">
                <know-before-you-go
                  :data="need_to_know"
                  :freeDays="siteInfo.free_days"
                  :accepted="pass.accepted"
                  :passTypeDefinition="passTypeDefinition"
                  @updatePass="updatePass"
                />
              </div>
              <div class="col-md-4">
                <need-help :data="need_help" />
                <div class="bar"></div>
                <button type="button" class="btn btn-info" v-b-modal.faqModal>
                  Review FAQs...
                </button>
              </div>
            </div>
            <br />
            <acknowledgement
              v-if="acknowledgementContent"
              :acknowledgementText="this.acknowledgementContent"
              :name="'accepted'"
              @passUpdated="passUpdated"
              title="Acknowledgement"
              :error="errors['accepted']"
            />
            <div class="form-actions">
              <router-link
                class="btn btn-secondary btn-lg"
                :to="{ name: 'orderDetails' }"
                v-if="this.$route.query.additional"
                >Cancel and Return to Cart</router-link
              >&nbsp;
              <button
                class="btn btn-primary btn-lg"
                type="button"
                id="addPassButton"
                @click="saveAndContinue"
                :disabled="!canContinue"
                v-if="!loading"
              >
                Add Pass
                <font-awesome-icon icon="chevron-right" class="fa fa-fw" />
              </button>
              <span v-if="loading">
                <font-awesome-icon
                  icon="spinner"
                  class="fa fa-fw fa-pulse fa-2x"
                />
              </span>
              <div class="error">{{ serverValidationErrorMessage }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <faq-list :faq="faq" />
    <the-footer />
    <blackout-periods
      :startdate="pass['start-date']"
      :blackout_periods="siteInfo.blackout_periods"
      :passtype="pass.passtype"
      :passTypeDefinition="passTypeDefinition"
    />
    <fee-free-days
      :startdate="pass['start-date']"
      :free_days="siteInfo.free_days"
    />
    <pass-type-unavailable
      :price="pass.price"
      :title="unavailableTitle"
      :description="unavailableDescription"
      :passType="pass['start-date']"
    />
  </div>
</template>

<script>
import TheHeader from "@/components/Shared/TheHeader.vue";
import TheFooter from "@/components/Shared/TheFooter.vue";
import PassInputFields from "@/components/Passes/PassInputFields.vue";
import KnowBeforeYouGo from "@/components/Passes/KnowBeforeYouGo.vue";
import NeedHelp from "@/components/Passes/NeedHelp.vue";
import FaqList from "@/components/Passes/FaqList.vue";
import BlackoutPeriods from "@/components/Passes/BlackoutPeriods.vue";
import FeeFreeDays from "@/components/Passes/FeeFreeDays.vue";
import PassTypeUnavailable from "@/components/Passes/PassTypeUnavailable.vue";
import DayNight from "@/components/Passes/DayNight.vue";
import Acknowledgement from "@/components/Passes/Acknowledgement.vue";
import Discount from "@/components/Passes/Discount.vue";
import FeeDisplay from "@/components/Passes/FeeDisplay.vue";
import SitesOffline from "@/components/Passes/SitesOffline.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapGetters, mapMutations, mapActions } from "vuex";
library.add(faChevronRight, faSpinner);

export default {
  components: {
    TheHeader,
    TheFooter,
    PassInputFields,
    KnowBeforeYouGo,
    NeedHelp,
    FaqList,
    BlackoutPeriods,
    FeeFreeDays,
    FontAwesomeIcon,
    PassTypeUnavailable,
    DayNight,
    Acknowledgement,
    Discount,
    FeeDisplay,
    SitesOffline,
  },
  data() {
    return {
      need_to_know: {},
      need_help: {},
      faq: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters("passInput", {
      pass: "pass",
      siteId: "siteId",
      passMetadata: "passMetadata",
      errors: "errors",
      siteInfo: "siteDefinition",
      passDefinition: "passDefinition",
      serverValidationErrorMessage: "serverValidationErrorMessage",
    }),
    siteOfflineMaintenance() {  
      return false;  
      // return (
      //   this.siteInfo.agency == "NPS" ||
      //   this.siteInfo.agency == "USFS" ||
      //   this.siteInfo.agency == "BLM"
      // );
    },
    siteOffline() {
      return (
        (this.siteInfo.agency == "NPS" &&
          this.siteId != "72451" &&
          this.siteId != "74295" &&
          this.siteId != "72448" &&
          this.siteId != "74290" &&
          this.siteId != "74282" &&
          this.siteId != "74278" &&
          this.siteId != "2665" &&
          this.siteId != "72477" &&
          this.siteId != "74293" &&
          this.siteId != "2727" &&
          this.siteId != "2604" &&
          this.siteId != "74271" &&
          this.siteId != "2699" &&
          this.siteId != "72446" &&
          this.siteId != "72471" &&
          this.siteId != "72396" &&
          this.siteId != "74270" &&
          this.siteId != "74289" &&
          this.siteId != "74330" &&
          this.siteId != "72488" &&
          this.siteId != "74334" &&
          this.siteId != "2853" &&
          this.siteId != "74280" &&
          this.siteId != "72441" &&
          this.siteId != "111891" &&
          this.siteId != "2943" &&
          this.siteId != "2788" &&
          this.siteId != "72144" &&
          this.siteId != "2744" &&
          this.siteId != "2972" &&
          this.siteId != "2987" &&
          this.siteId != "2708" &&
          this.siteId != "73983" &&
          this.siteId != "2627" &&
          this.siteId != "2829" &&
          this.siteId != "2620" &&
          this.siteId != "72465" &&
          this.siteId != "2704" &&
          this.siteId != "74296" &&
          this.siteId != "72449" &&
          this.siteId != "74470" &&
          this.siteId != "74388") ||
        this.siteId == "74440"
      );
    },
    canContinue() {
      if (this.pass.price === "unavailable") {
        return false;
      }
      // if (
      //   this.passTypeDefinition &&
      //   this.passTypeDefinition.features &&
      //   this.passTypeDefinition.features.accepted &&
      //   !this.pass.accepted
      // ) {
      //   return false;
      // }
      return true;
    },
    acknowledgementContent() {
      if (
        !this.passTypeDefinition ||
        !this.passTypeDefinition.features ||
        !this.passTypeDefinition.features.accepted ||
        !this.siteInfo ||
        !this.siteInfo.contents ||
        !this.siteInfo.contents[this.passTypeDefinition.features.accepted[0]]
      ) {
        return;
      }

      let title =
        this.siteInfo.contents[this.passTypeDefinition.features.accepted[0]][0]
          .title;
      return "I have read and agree to the terms in the " + title + " section";
    },
    passTypeDefinition() {
      if (!this.pass.passtype) {
        return;
      }
      return this.passDefinition.pass_types.find(
        (n) => n.id === this.pass.passtype
      );
    },
    unavailableTitle() {
      //Acadia has a special message
      if (this.siteId == 74271) {
        return "No Purchase Required";
      }
      //All other parks, just show generic pass not available
      else {
        return "Pass Not Available";
      }
    },
    unavailableDescription() {
      //Acadia has special message
      if (this.siteId == 74271) {
        return "Park visitors are not required to pay an entrance fee to enter the park from November – April.";
      }
      //All other parks, just show generic pass not available
      else {
        return "Pass type is not available for the dates selected.";
      }
    },
    pricingDescriptions() {
      if (
        this.siteInfo &&
        this.siteInfo.contents &&
        this.siteInfo.contents.pricing
      ) {
        return this.siteInfo.contents.pricing;
      }
      return null;
    },
  },
  watch: {
    siteInfo() {
      if (!this.siteInfo || !this.siteInfo.contents) {
        return;
      }
      if (this.siteInfo.contents.need_to_know) {
        this.need_to_know = this.siteInfo.contents.need_to_know[0];
      }
      if (this.siteInfo.contents.need_help) {
        this.need_help = this.siteInfo.contents.need_help[0];
      }
      if (this.siteInfo.contents.faq) {
        this.faq = this.siteInfo.contents.faq;
      }
    },
  },
  methods: {
    ...mapMutations("passInput", ["clear", "setSiteId", "updatePass"]),
    ...mapActions("passInput", [
      "loadSiteDefinition",
      "loadPassTypeDefinition",
      "updatePassFields",
      "refreshPassMetadata",
      "setPassDefaultValues",
    ]),
    passUpdated(field) {
      this.updatePass(field);
      this.updatePassFields();
      this.refreshPassMetadata();
      this.setPassDefaultValues();
    },
    saveAndContinue() {
      this.loading = true;
      this.validatePass().then(() => {
        let hasErrors = false;
        for (var error in this.errors) {
          if (this.errors[error] && this.errors[error] != "") {
            hasErrors = true;
          }
        }
        if (!hasErrors && this.serverValidationErrorMessage === "") {
          this.$store.commit("cart/addPassToCart", this.pass);
          this.clear();
          this.loading = false;
          this.$router.push({ name: "orderDetails" });
        } else {
          this.loading = false;
          window.scrollTo(0, 0);
        }
      });
    },
    validatePass() {
      return this.$store.dispatch("passInput/validatePass");
    },
  },
  created() {
    this.setSiteId(this.$route.params.siteId);
    //Site and pass definitions are loaded async
    this.loadSiteDefinition();
    this.loadPassTypeDefinition();
  },
};
</script>
